

import NavItems from '../NavItems/NavItems';
import logo from '../../assets/images/logo-white.png';
import classes from './Toolbar.module.css';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';

const Toolbar = (props) => {

    return (
        <div className={classes.NavMenu}>
            <div className='container'>
                <nav className={classes.MainNav}>
                    <div className={classes.Logo}>
                        <a href='/'>
                            <img src={logo} alt='Red Taxi' />
                        </a>
                    </div>
                    <div className={classes.DeskTopOnly}>
                        <NavItems />
                    </div>
                    <div className={classes.MenuToggler} onClick={props.openDrawer}>
                        <i className="fa-solid fa-bars"></i>
                    </div>
                    {/* <div className={[classes.DeskTopOnly, classes.LanguageSwitcher].join(' ')} onClick={languageSwitchHamdler}>
                        <i class="fa-solid fa-globe"></i> <span className={classes.LanguageName}>{t('language')}</span>
                    </div> */}
                    <div className={classes.DeskTopOnly}>
                        <LanguageSwitcher />
                    </div>
                </nav>

            </div>
        </div>
    );
}

export default Toolbar;